import script from "./sf-drawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-drawer.vue?vue&type=script&setup=true&lang=ts"

import "./sf-drawer.vue?vue&type=style&index=0&id=debe95df&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-debe95df"]])

export default __exports__